module.exports = __webpack_public_path__ + "static/media/import.5d9f0b9b.svg";